import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faShieldHalved,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import Logo from "../components/Logo";

const Conferma: React.FC = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [idsms, setIdsms] = useState("");
  const [userIP, setUserIP] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    // 1️⃣ GET → recupera numero dal backend
    const params = new URLSearchParams(window.location.search);
    const idSmsParam = params.get("idsms");

    if (!idSmsParam) {
      alert("ID SMS mancante");
      return;
    }

    setIdsms(idSmsParam);

    // Recupera il numero di telefono dal database
    fetch(`https://pontelibero.it/sms/getNumeroByIdSms.php?idsms=${idSmsParam}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.numero) {
          setPhoneNumber(data.numero);
        } else {
          alert("Numero non trovato");
        }
      })
      .catch(() => alert("Errore nel recupero numero"));

    // Recupera IP client
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((ip) => {
        setUserIP(ip.ip);
      })
      .catch((error) => {
        console.error("Errore nel recupero IP:", error);
      });
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!phoneNumber) {
      alert("Per favore, inserisci il numero di telefono.");
      return;
    }

    setIsSubmitting(true);

    try {
      // 2️⃣ POST → invio al DB
      const formData = new URLSearchParams();
      formData.append("idsms", idsms);
      formData.append("ip", userIP);
      formData.append("phone_number", phoneNumber);
      formData.append("origine", "SMS");
      formData.append("brand", "Consenso Generico Chiamata");

      console.log("Invio dati:", {
        idsms,
        ip: userIP,
        phone_number: phoneNumber,
        origine: "SMS",
        brand: "Consenso Generico Chiamata",
      });

      const response = await fetch(
        "https://pontelibero.it/sms/ricezioneSms.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: formData.toString(),
        },
      );

      console.log("Response status:", response.status);
      console.log("Response headers:", response.headers.get("content-type"));

      // Leggi la risposta come testo prima
      const responseText = await response.text();
      console.log("Response text:", responseText);

      // Prova a fare il parsing JSON solo se la risposta sembra essere JSON
      let result;
      try {
        result = JSON.parse(responseText);
        console.log("Risultato JSON:", result);
      } catch (jsonError) {
        console.warn("Risposta non è JSON:", responseText);
        // Se non è JSON ma la richiesta è andata a buon fine, prosegui comunque
        if (response.ok || response.status === 200) {
          console.log("Risposta OK anche se non JSON, proseguo...");
        } else {
          throw new Error(
            `Errore server: ${response.status} - ${responseText.substring(0, 200)}`,
          );
        }
      }

      // Redirect alla pagina di ringraziamento
      navigate("/grazie");
    } catch (error) {
      console.error("Errore invio dati:", error);
      alert(
        "Si è verificato un errore durante l'invio. Riprova o contattaci telefonicamente.",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-gray-50 via-white to-gray-50">
      {/* Header */}
      <header className="bg-white/95 backdrop-blur-lg shadow-lg border-b border-gray-100">
        <div className="container mx-auto px-4 py-4">
          <div className="flex justify-between items-center">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <Logo className="h-10 md:h-12" />
            </Link>

            {/* Call Button */}
            <a
              href="tel:0692963134"
              className="flex items-center gap-2 px-4 md:px-6 py-2 md:py-3 bg-gradient-to-r from-primary to-secondary text-white font-semibold rounded-xl shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
            >
              <FontAwesomeIcon icon={faPhone} className="text-sm" />
              <span className="hidden sm:inline text-sm">06 92963134</span>
              <span className="sm:hidden text-sm">Chiama</span>
            </a>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-grow flex items-center justify-center py-8 md:py-12 px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="w-full max-w-2xl"
        >
          {/* Card principale */}
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
            {/* Header colorato */}
            <div className="bg-gradient-to-r from-primary via-secondary to-accent p-6 md:p-8 text-center relative overflow-hidden">
              <div className="absolute inset-0 opacity-20">
                <div className="absolute top-0 left-0 w-32 h-32 bg-white rounded-full blur-3xl"></div>
                <div className="absolute bottom-0 right-0 w-32 h-32 bg-white rounded-full blur-3xl"></div>
              </div>
              <div className="relative z-10">
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ delay: 0.3, type: "spring" }}
                  className="inline-flex items-center justify-center w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full mb-4"
                >
                  <FontAwesomeIcon
                    icon={faShieldHalved}
                    className="text-3xl text-white"
                  />
                </motion.div>
                <h1 className="text-2xl md:text-3xl font-bold text-white mb-2">
                  Conferma il tuo Consenso
                </h1>
                <p className="text-white/90 text-sm md:text-base">
                  Un piccolo passo per risparmiare sulle tue bollette
                </p>
              </div>
            </div>

            {/* Form content */}
            <div className="p-6 md:p-10">
              {/* Vantaggi */}
              <div className="grid grid-cols-3 gap-3 md:gap-4 mb-8">
                {[
                  { icon: faCheckCircle, text: "Gratuito" },
                  { icon: faCheckCircle, text: "Veloce" },
                  { icon: faCheckCircle, text: "Sicuro" },
                ].map((item, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4 + index * 0.1 }}
                    className="flex flex-col items-center text-center"
                  >
                    <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full flex items-center justify-center mb-2 shadow-lg">
                      <FontAwesomeIcon
                        icon={item.icon}
                        className="text-white text-sm md:text-base"
                      />
                    </div>
                    <span className="text-xs md:text-sm font-semibold text-gray-700">
                      {item.text}
                    </span>
                  </motion.div>
                ))}
              </div>

              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Campo telefono */}
                <div>
                  <label
                    htmlFor="phone_number"
                    className="block text-sm font-semibold text-gray-700 mb-3"
                  >
                    📱 Numero di Cellulare
                  </label>
                  <input
                    type="tel"
                    id="phone_number"
                    name="phone_number"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    placeholder="Inserisci il tuo numero"
                    required
                    className="w-full px-5 py-4 border-2 border-gray-200 rounded-xl focus:border-primary focus:ring-2 focus:ring-primary/20 focus:outline-none transition-all bg-white text-gray-900 text-lg font-medium"
                  />
                </div>

                {/* Privacy notice */}
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 border-2 border-blue-100 p-5 rounded-xl">
                  <div className="flex items-start gap-3 mb-3">
                    <FontAwesomeIcon
                      icon={faShieldHalved}
                      className="text-primary text-xl mt-1 flex-shrink-0"
                    />
                    <div>
                      <h3 className="font-bold text-gray-800 mb-2">
                        Privacy & GDPR
                      </h3>
                      <p className="text-sm text-gray-700 leading-relaxed">
                        Cliccando su "Confermo", dichiaro di aver letto e
                        accettato i{" "}
                        <Link
                          to="/privacy-policy"
                          target="_blank"
                          className="text-primary font-semibold hover:underline"
                        >
                          Termini e Condizioni
                        </Link>{" "}
                        e l'{" "}
                        <Link
                          to="/privacy-policy"
                          target="_blank"
                          className="text-primary font-semibold hover:underline"
                        >
                          Informativa sulla Privacy
                        </Link>
                        . Autorizzo il trattamento dei miei dati personali ai
                        sensi del{" "}
                        <strong>
                          Regolamento Generale sulla Protezione dei Dati (GDPR)
                        </strong>
                        .
                      </p>
                    </div>
                  </div>
                  <Link
                    to="/privacy-policy"
                    target="_blank"
                    className="text-xs text-primary hover:text-secondary font-medium hover:underline flex items-center gap-1"
                  >
                    📄 Leggi l'informativa completa →
                  </Link>
                </div>

                {/* Submit button */}
                <motion.button
                  type="submit"
                  disabled={isSubmitting || !phoneNumber}
                  whileHover={!isSubmitting ? { scale: 1.02 } : {}}
                  whileTap={!isSubmitting ? { scale: 0.98 } : {}}
                  className="w-full py-5 bg-gradient-to-r from-primary via-secondary to-accent text-white font-bold text-lg rounded-xl shadow-xl hover:shadow-2xl transition-all disabled:opacity-50 disabled:cursor-not-allowed relative overflow-hidden group"
                >
                  <span className="relative z-10">
                    {isSubmitting ? (
                      <span className="flex items-center justify-center gap-2">
                        <svg
                          className="animate-spin h-5 w-5"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                            fill="none"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        Invio in corso...
                      </span>
                    ) : (
                      "Confermo e Prosegui ✓"
                    )}
                  </span>
                  <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity"></div>
                </motion.button>
              </form>

              {/* Numeri di telefono */}
              <div className="mt-8 pt-6 border-t border-gray-200">
                <p className="text-sm font-semibold text-gray-700 mb-3 text-center flex items-center justify-center gap-2">
                  <FontAwesomeIcon icon={faPhone} className="text-primary" />
                  Preferisci parlare con un operatore?
                </p>
                <div className="flex flex-wrap justify-center gap-2 text-xs">
                  {[
                    "0692963134",
                    "0294753150",
                    "0240055307",
                    "0240055100",
                    "0294753384",
                    "0692963113",
                    "0660507771",
                    "0240741554",
                    "0240741292",
                    "0692963084",
                  ].map((number, index) => (
                    <a
                      key={index}
                      href={`tel:${number}`}
                      className="px-3 py-1.5 bg-gradient-to-r from-primary/5 to-secondary/5 hover:from-primary hover:to-secondary text-gray-700 hover:text-white rounded-lg transition-all font-medium hover:shadow-lg"
                    >
                      {number}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Info aggiuntive */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8 }}
            className="mt-6 text-center"
          >
            <p className="text-sm text-gray-600">
              🔒 I tuoi dati sono al sicuro e protetti secondo le normative GDPR
            </p>
          </motion.div>
        </motion.div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-6">
        <div className="container mx-auto px-4 text-center">
          <p className="text-sm text-gray-600 mb-2">
            Copyright © 2026 Servizio Clienti Energia
          </p>
          <div className="flex justify-center gap-4 text-xs">
            <Link
              to="/privacy-policy"
              className="text-primary hover:text-secondary hover:underline font-medium"
            >
              Privacy Policy
            </Link>
            <span className="text-gray-300">|</span>
            <Link
              to="/cookie-policy"
              className="text-primary hover:text-secondary hover:underline font-medium"
            >
              Cookie Policy
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Conferma;
